var public_nurseslounge_job_jobDetail = {
    init:function($params){
        var $job = JSON.parse(libs.unlock($params));
        public_nurseslounge_job_jobDetail.information_events($job);
        try{
            google.maps.event.addListener(window, "load", public_nurseslounge_job_jobDetail.information_location_map($job));
        }catch (e) {

        }
        public_nurseslounge_job_jobDetail.banners_location(function($config){
            nurseslounge_myDashboard_myProfile.banners_engine($config);
        });
    },
    information_events:function($job){
        $(".nav-underline a:eq(0)").addClass('active');
        var $loungeInformation = $("#nurseslounge-job-information");
        var $loungeInformationRight = $loungeInformation.find('.nurseslounge-job-information-right');
        var $loungeInformationLeft = $loungeInformation.find('.nurseslounge-job-information-left');
        var $applyOnWebsite = $loungeInformationLeft.find('.apply-on-website');
        var $whyWorkHere = $loungeInformationLeft.find('.why-work-here');
        var $readMore = $loungeInformationLeft.find('.read-more');
        var $addReview = $loungeInformationRight.find('.add-review');
        var $discoverMoreJobs = $loungeInformationRight.find('.discover-more-jobs');
        var $discoverMoreDegrees = $loungeInformationRight.find('.discover-more-degrees');
        var $nav = $(".nav-underline");
        var $key = $nav.data('key');
        var $jobKey = $nav.data('job_key');
        var $params = {key:$key, job_key:$jobKey};
        $whyWorkHere.unbind().click(function(){
            window.open($job.lounge.public_link, '_blank');
        });
        $readMore.unbind().click(function(){
            $params = $.extend({}, $params, {id:'jobDetail'});
            public_nurseslounge_lounge_overview.login_popup($params);
        });
        $applyOnWebsite.unbind().click(function(){
            $params = $.extend({}, $params, {id:'nursingJobs'});
            public_nurseslounge_lounge_overview.login_popup($params);
        });
        $addReview.unbind().click(function(){
            $params = $.extend({}, $params, {id:'jobRatingReviews'});
            public_nurseslounge_lounge_overview.login_popup($params);
        });
        $discoverMoreJobs.unbind().click(function(){
            $params = $.extend({}, $params, {id:'nursingJobs'});
            public_nurseslounge_lounge_overview.login_popup($params);
        });
        $discoverMoreDegrees.unbind().click(function(){
            $params = $.extend({}, $params, {id:'degrees'});
            public_nurseslounge_lounge_overview.login_popup($params);
        });
        $(".nav-underline a").unbind().click(function(){
            var $that = $(this);
            var $id = $that.data('id');
            $params = $.extend({}, $params, {id:$id});
            public_nurseslounge_lounge_overview.login_popup($params);
        });
    },
    information_location_map:function($job){
        var $location = $job.location && $job.location ? $job.location : null;
        if($location && $location.address_latitude && $location.address_longitude && $location.address_is_unmappable == 0){
            var $position = new google.maps.LatLng(parseFloat($location.address_latitude), parseFloat($location.address_longitude));
            var $iconUrl =  './../../../../bimg/NursesLounge/active.png';
            var $map = new google.maps.Map(document.getElementById('nurseslounge-job-information-right-map'), {
                center:$position,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: false,
                zoom: 15
            });
            $map.setTilt(0);
            var $marker = new google.maps.Marker({
                position:$position,
                map: $map,
                animation: google.maps.Animation.DROP,
                icon: {url:$iconUrl, scaledSize: (new google.maps.Size(20, 35))},
            });
        }
    },
    //Banners
    banners_location:function(cback){
        cback({
            'banners':$("#nurseslounge-job-information .nurseslounge-job-information-right .banners")
        });
    }
};
